import naja from 'naja'

// Provede požadavek ale nezapíše záznam do historie
naja.uiHandler.addEventListener('interaction', (e) => {
    e.stopImmediatePropagation()
})


/*
ZATÍM SE NIKDE NEPOUŽÍVÁ
Po překreslení snippetů vždy znovu nastavíme listenery pro elementy se třídou ajax
naja.snippetHandler.addEventListener('afterUpdate', e => {
    // TODO zde ještě zřejmě bude nutné zařídit aby se vyselectovaly pouze elementy uvnitř překresleného snippetu
    document.querySelectorAll('.ajax').forEach(element => {
        naja.uiHandler.bindUI(element)
        console.log(element)
    })
})
*/